<style lang="scss" scoped></style>

<template>
  <td>
    <div @click="copy()" class="btn btn-primary">Kopieren</div>
  </td>
</template>

<script lang="babel">
export default {
    props: ['content'],
    methods: {
      copy() {
        navigator.clipboard.writeText(this.content);
        this.$notify({
            title: "Text kopiert",
            type: "success"
        });
      }
    }
};
</script>
